// @index('./*', pp => `import * as ${pp.name} from '${pp.path}/index';`, { "ignore": ["./*.ts", "./*.md", "./setupTests.cjs"] })
import * as detail from './detail/index';
// @endindex
// @index('./*.ts', pp => `import { ${pp.name} } from '${pp.path}';`)
import { EventListener } from './EventListener';
import { EventPublish } from './EventPublish';
import { EventSource } from './EventSource';
import { EventSubscription } from './EventSubscription';
import { EventTypeDetail } from './EventTypeDetail';
import { EventTypes } from './EventTypes';
// @endindex
export {
	// @index('./*', pp => `${pp.name},`, { "ignore": ["setupTests.cjs"]})
	detail,
	EventListener,
	EventPublish,
	EventSource,
	EventSubscription,
	EventTypeDetail,
	EventTypes,
	// @endindex
};



// WEBPACK FOOTER //
// ./src/models/eventManager/index.ts